<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BjFHG0/tc-custom/9781035842735.jpg?1725723409019" alt="This image is the cover for the book Caterpillar's Journey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Caterpillar's Journey
      </h1>
      <p class="bookDescription body article font2">
        <p>Caterpillar’s Journey takes readers (moms, dads, grandparents, and more) on an enchanting adventure through the life of a little caterpillar. From hatching out of her egg to transforming into a beautiful butterfly, this story blends biological accuracy with fairytale magic. The woodland animals, along with the caterpillar herself, talk, think, and feel like humans, sharing their dreams and aspirations. This heartwarming tale touches the heart, mind, and soul of anyone, young or old, who is open to the wonders of nature, spirit, and life itself.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Irene MacKay, Lara Gallagher
      </h2>
      
      <p class="authorDescription body article">Irene MacKay is Canadian but has been a resident of Switzerland for more than 40 years. She lives in an old farmhouse in the Jura Mountains together with her husband and 15 cats. Before retirement she worked as a teacher in international and national schools in Switzerland and Canada. She enjoys hiking and spending time in the wilderness of her natural garden, observing and learning to communicate with foxes, hedgehogs, martens, wild birds, plants and trees.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?789381a6